import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function RegisterPage() {
  const navigate = useNavigate()
  const { register, checkStatus } = useAuth()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [statusCheck, setStatusCheck] = useState<{ status: string } | null>(null)

  const handleStatusCheck = async () => {
    if (!email) return
    const result = await checkStatus(email)
    setStatusCheck(result)
    if (result?.status === 'approved') {
      setError('')
    } else if (result?.status === 'pending') {
      setError('Este email já tem um pré-cadastro pendente de aprovação.')
    } else if (result?.status === 'rejected') {
      setError('Este email foi rejeitado. Crie uma nova conta ou entre em contato.')
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (password !== confirmPassword) {
      setError('As senhas não coincidem')
      return
    }

    if (password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres')
      return
    }

    setLoading(true)
    try {
      await register(name, email, password)
      navigate('/under-review')
    } catch (err: unknown) {
      const axiosError = err as { response?: { data?: { detail?: string | string[] } } }
      const detail = axiosError.response?.data?.detail
      setError(
        Array.isArray(detail) ? detail.join('; ') : typeof detail === 'string' ? detail : 'Falha ao criar conta',
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-[var(--color-surface)] rounded-2xl border border-[var(--color-border)] shadow-sm p-8">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-[var(--color-text)]">FinApp</h1>
        <p className="mt-1 text-[var(--color-text-muted)]">Crie sua conta</p>
      </div>

      <form onSubmit={handleSubmit} className="mt-8 space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-[var(--color-text)]">
            Nome
          </label>
          <input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Seu nome"
            required
            className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-[var(--color-text)]">
            E-mail
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              setStatusCheck(null)
              setError('')
            }}
            placeholder="voce@exemplo.com"
            required
            className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-[var(--color-text)]">
            Senha
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mínimo 6 caracteres"
            required
            minLength={6}
            className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
          />
        </div>

        <div>
          <label htmlFor="confirmPassword" className="block text-sm font-medium text-[var(--color-text)]">
            Confirmar senha
          </label>
          <input
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Repita a senha"
            required
            className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
          />
        </div>

        {statusCheck && statusCheck.status !== 'not_found' && (
          <p className="text-sm text-[var(--color-text-muted)]">Status do cadastro: {statusCheck.status}</p>
        )}

        {error ? <p className="text-sm text-[var(--color-danger)]">{error}</p> : null}

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-lg bg-[var(--color-brand-500)] px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-[var(--color-brand-600)] disabled:opacity-50"
        >
          {loading ? 'Criando conta...' : 'Solicitar cadastro'}
        </button>
      </form>

      <div className="mt-6 flex items-center justify-between text-sm">
        <p className="text-[var(--color-text-muted)]">
          Já tem conta?{' '}
          <a href="/login" className="text-[var(--color-brand-500)] font-medium hover:underline">
            Entrar
          </a>
        </p>
        <button
          type="button"
          disabled={!email || loading}
          onClick={handleStatusCheck}
          className="rounded border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-1.5 text-[var(--color-text-muted)] hover:bg-[var(--color-surface-subtle)] disabled:opacity-50"
        >
          Verificar status
        </button>
      </div>
    </div>
  )
}
